import { computed } from "@vue/composition-api";
import { Location } from "vue-router";
import Store from "@/store";
import { MUTATION_TYPES } from "@/store/const";

export default function useStateRedirectPath() {
  const stateRedirectPath = computed({
    get() {
      return Store.state.redirectPath;
    },
    set(savedPath: Location | null) {
      Store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, savedPath);
    },
  });
  return { stateRedirectPath };
}
